// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { loadStripe } from '@stripe/stripe-js';

// 🔑 Your Firebase Project Configuration
const firebaseConfig = {
  apiKey: "AIzaSyAv8HWudvBKxgXinj361nrxyLtX-zEx0K4",
  authDomain: "aulice-hub.firebaseapp.com",
  projectId: "aulice-hub",
  storageBucket: "aulice-hub.firebasestorage.app",
  messagingSenderId: "966761974696",
  appId: "1:966761974696:web:bd987a5e805f9bb9ba2b9d"
};

// 🚀 Initialize Firebase
const app = initializeApp(firebaseConfig);

// 💳 Initialize Stripe
const stripePromise = loadStripe(
  "pk_live_51S9DkiKAY8PM72prvmp314epvLZbw2twhHmzEPMHK0NXGA5ibkhG58ee4iXhBocVPVCmbyFKncklGRF2j0jpsRcP00m7dtEiG7"
);

// 🛠️ Get Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "us-central1"); // ✅ Explicit region for Cloud Functions

// 📤 Export everything for use across the app
export { app, auth, db, functions, stripePromise };